export default __webpack_public_path__ + "static/media/loader.46f1ece5.gif";